$(function () {
  var MilestoneProgress = {
    $section: $("#tf-26-preregister-milestone"),
    BAR_WIDTH: 900,

    init: function () {
      if (!this.$section.length) return;

      var currentPoint =
        typeof pointMilestone !== "undefined" ? pointMilestone : 0;
      var maxPoint =
        parseInt(
          this.$section.find(".milestone__progress").data("milestone-max"),
        ) || 3000000;

      this.updateProgress(currentPoint, maxPoint);
    },

    updateProgress: function (point, max) {
      var $dots = this.$section.find(".milestone__dot--item");
      var targets = $dots
        .map(function () {
          return parseInt($(this).data("target")) || 0;
        })
        .get();

      if (!targets.length) return;

      point = Math.min(Math.max(point, 0), max);

      var progressWidth = this.calculateProgressWidth(point, targets);

      // Update UI
      this.$section
        .find(".milestone__progress--current")
        .css("width", progressWidth + "px");
      this.$section.find(".milestone__key").css("left", progressWidth + "px");

      // Mark completed milestones
      $dots.each(function () {
        var target = parseInt($(this).data("target")) || 0;
        $(this).toggleClass("is-done", point >= target);
      });
    },

    calculateProgressWidth: function (point, targets) {
      var numDots = targets.length;
      var dotPositions = [];

      // Calculate dot positions (space-between layout)
      for (var i = 0; i < numDots; i++) {
        dotPositions.push((i * this.BAR_WIDTH) / (numDots - 1));
      }

      // Before first milestone
      if (point < targets[0]) {
        return Math.round((point / targets[0]) * dotPositions[0]);
      }

      // After last milestone
      if (point >= targets[numDots - 1]) {
        return this.BAR_WIDTH;
      }

      // Between milestones - interpolate
      for (var i = 0; i < numDots - 1; i++) {
        if (point >= targets[i] && point < targets[i + 1]) {
          var segmentRatio =
            (point - targets[i]) / (targets[i + 1] - targets[i]);
          var segmentWidth = dotPositions[i + 1] - dotPositions[i];
          return Math.round(dotPositions[i] + segmentRatio * segmentWidth);
        }
      }

      return 0;
    },
  };

  MilestoneProgress.init();
});
